import { render, staticRenderFns } from "./helpPerformance.vue?vue&type=template&id=760f8157"
import script from "./helpPerformance.vue?vue&type=script&lang=js"
export * from "./helpPerformance.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports